import { openApp } from '@bilibili-maoer/prelude'
import { app, mobile } from '@bilibili-maoer/web-utils'

import { PropsWithChildren } from 'react'

import { Link as MuiLink } from '@mui/material'

export const gotoBindMobile = () => {
  if (mobile.isMissEvanApp()) {
    app.openAppByProtocol('security', 'account')
  } else {
    openApp({ type: 'account', path: 'security' })
  }
}

export const BindMobile = (props: PropsWithChildren<{}>) => (
  <MuiLink onClick={() => gotoBindMobile()}>{props.children}</MuiLink>
)
